import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Grid,
  Tab,
  Tabs,
  Typography,
  Select,
  MenuItem,
} from '@material-ui/core';

import TabPanel from './TabPanel';

import graph from '../../assets/graph.svg';

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: 50,
    width: 'auto',
    padding: 8,
    position: 'relative',
    fontWeight: 600,
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
    borderStyle: 'solid',
  },
  noUppercase: {
    textTransform: 'none',
  },
  fullWidth: {
    width: '100%',
  },
  tabs: {
    flexGrow: 1,
  },
  tab: {
    flexGrow: 1,
  },
}));

export default function HomeSummaryTile({
  total,
  status,
  disableGraphs,
}) {
  const classes = useStyles();

  const [currentTab, setCurrentTab] = React.useState(0);
  const [period, setPeriod] = React.useState('all');

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handlePeriodChange = (event) => {
    setPeriod(event.target.value);
  };

  return (
    <div className="home-summary-tile">
      <Tabs
        className={classes.tabs}
        value={currentTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleTabChange}
        variant="fullWidth"
      >
        <Tab className={classes.tab} label="Total" />
        { !disableGraphs && (<Tab className={classes.tab} label="Graph" />) }
      </Tabs>
      <Box>
        <TabPanel className={classes.panel} value={currentTab} index={0}>
          <Typography component="p" variant="h1" style={{ color: 'black', lineHeight: 1, height: 110 }}>
            { total }
          </Typography>
        </TabPanel>
        { !disableGraphs && (
          <TabPanel className={classes.panel} value={currentTab} index={1}>
            <img height="103" className={classes.graph} src={graph} alt={`Graph ${status}`} />
          </TabPanel>
        ) }
      </Box>
      <Grid container xs={12} justifyContent="flex-end">
        <Select
          style={{ minWidth: 100 }}
          value={period}
          onChange={handlePeriodChange}
        >
          <MenuItem value="day" disabled>Day</MenuItem>
          <MenuItem value="week" disabled>Week</MenuItem>
          <MenuItem value="month" disabled>Month</MenuItem>
          <MenuItem value="year" disabled>Year</MenuItem>
          <MenuItem value="all">All Time</MenuItem>
        </Select>
      </Grid>
    </div>
  );
}
